module.exports = __webpack_public_path__ + "img/Flag_of_Djibouti.3c879837.svg";